import { Events } from '@APP/events/app-events';
import { requires } from '@APP/mixins/dependency';
import { ReactiveList } from '@APP/model/reactive-list';
import { eventBus } from '@APP/utils/event-bus';
import { BaseService } from './base-service';
import { IDataProviderService } from './data-provider';
import { QuestionsService } from './questions-service';

type DEPS = {
  questionsService: QuestionsService;
};

@requires(QuestionsService.serviceName)
class CoveragesDataProvider
  extends BaseService<DEPS>
  implements IDataProviderService {
  static serviceName = 'coveragesDataProvider';

  private coveragesTypes: ReactiveList<string, any> = new ReactiveList('coverages');

  constructor() {
    super();
    eventBus().on(Events.Type.QuestionUpdate, (event) => {
      if (event.questionId == 'manufacture_year' || event.questionId == 'userDefinedBoatValue' || event.questionId == 'UserOverrideBoatValue') {
        this.populateList();
      }
    });
  }


  getList(name: string): ReactiveList<any, any> {
    if (name !== 'coverageType') {
      throw new Error('Unknown list');
    }
    this.populateList();
    return this.coveragesTypes;
  }

  private populateList() {
    this.coveragesTypes.setState('pending');

    this.coveragesTypes.options = this.deps.questionsService.model.getCoverageTypes();

    this.coveragesTypes.setState('ready');
  }
}

export { CoveragesDataProvider };

CoveragesDataProvider.define();
